import { format } from "date-fns";

/**
 * Parse date string (YYYY-MM-DD) in local timezone.
 * Prevents off-by-one errors from UTC conversion.
 */
export function parseLocalDate(dateString: string): Date {
  return new Date(dateString + "T00:00:00");
}

/**
 * Format a date range intelligently based on the span:
 * - Monthly data: "January 2026"
 * - Same month: "Jan 1 - 7, 2026"
 * - Different months: "Jan 30 - Feb 5, 2026"
 */
export function formatDateRange(startStr: string, endStr: string): string {
  const startDate = parseLocalDate(startStr);
  const endDate = parseLocalDate(endStr);

  const isStartFirstOfMonth = startDate.getDate() === 1;
  const lastDayOfMonth = new Date(
    endDate.getFullYear(),
    endDate.getMonth() + 1,
    0,
  ).getDate();
  const isEndLastOfMonth = endDate.getDate() === lastDayOfMonth;

  const isMonthlyData =
    isStartFirstOfMonth &&
    isEndLastOfMonth &&
    startDate.getMonth() === endDate.getMonth() &&
    startDate.getFullYear() === endDate.getFullYear();

  if (isMonthlyData) {
    return format(startDate, "MMMM yyyy");
  } else if (
    startDate.getMonth() === endDate.getMonth() &&
    startDate.getFullYear() === endDate.getFullYear()
  ) {
    return `${format(startDate, "MMM d")} - ${format(endDate, "d, yyyy")}`;
  } else {
    return `${format(startDate, "MMM d")} - ${format(endDate, "MMM d, yyyy")}`;
  }
}
